<template>
  <mdb-modal size="lg" scrollable>
    <mdb-modal-header :close="false" class="text-center">
      <h5>{{ label }}</h5>
    </mdb-modal-header>
    <mdb-modal-body>
      <mdb-input id="message-subject" type="text" v-model="subject" label="Subject" v-if="requireSubject"/>
      <editor ref="editor" :init="editorConfig" v-model="text"/>
      <mdb-input id="post-admin-checkbox" label="Post as Admin?" type="checkbox"
                 v-model="postAsAdmin" v-if="currentUser.isAdmin"/>
      <mdb-btn @click="save" icon="paper-plane" :disabled="!text || (!subject&&requireSubject)">{{ buttonLabel }}
      </mdb-btn>
      <mdb-btn @click="cancel" color="danger" icon="times-circle">Cancel</mdb-btn>
    </mdb-modal-body>
  </mdb-modal>

</template>
<script>
import {mdbBtn, mdbIcon, mdbInput, mdbModal, mdbModalBody, mdbModalHeader} from 'mdbvue';
import editor from '@tinymce/tinymce-vue'
import api from "../../services/groupsPlaceApi";
import editorSettings from "../../services/editorSettings";

export default {
  name: 'messageCreate',
  components: {
    mdbModal,
    mdbModalHeader,
    mdbModalBody,
    mdbIcon,
    mdbBtn,
    mdbInput,
    editor
  },
  props: {
    label: {
      type: String,
      default: "Your Comment"
    },
    originalText: {
      type: String,
      default: null
    },
    originalSubject: {
      type: String,
      default: null
    },
    requireSubject: {
      type: Boolean,
      default: false
    },
    bodyPlaceholder: {
      type: String,
      default: "Say something nice..."
    },
    buttonLabel: {
      type: String,
      default: "Send"
    }
  },
  data() {
    return {
      text: "",
      subject: "",
      postAsAdmin: false,
      files: [],
      pastedImages: [],
      editorConfig: {
        browser_spellcheck: true,
        branding: false,
        plugins: ["image", "link", "code", "paste", "table", "lists"],
        images_upload_handler : this.handlePastedImage,
        toolbar: "undo redo | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist | link image",
        image_advtab: true,
        style_formats_merge: true,
        image_class_list: editorSettings.imageClassList(),
        formats: editorSettings.formats(),
        style_formats: editorSettings.styleFormats(),
        paste_as_text: true,
        paste_data_images: true,
        relative_urls: false,
        remove_script_host: false,
        height: 400,
        table_default_attributes: {
          class: "table table-responsive table-bordered table-striped table-hover",
          style: ""
        },
      }
    }
  },
  mounted() {
    let el
    if (this.requireSubject) el = document.getElementById("message-subject")
    else el = document.getElementById("message-body")
    if (el) el.focus()
    if (this.originalText) this.text = this.originalText
    if (this.originalSubject) this.subject = this.originalSubject
    let tw = editorSettings.theWorksInline()
    this.editorConfig.image_class_list = tw.image_class_list

  },
  computed: {
    currentUser() {
      return this.$store.state.userDetails
    }
  },
  methods: {
    cancel() {
      this.$emit("cancel")
    },
    save() {
      this.$emit("save", {text: this.text, subject: this.subject, postAsAdmin: this.postAsAdmin, files: this.files, pastedImages: this.pastedImages})
    },
    handlePastedImage: async function (blobInfo, success, failure, progress) {
      const reduce = require('image-blob-reduce')();
      this.$store.dispatch("setExecuting", true)
      let image = blobInfo.blob()
      console.log("Before Image name is ", image.name, image.type)
      if (image.size >= 1000000) {
        await reduce.toBlob(image, {max: 1000})
          .then(blob => {
            image.file = blob
          })
      }

      console.log("Blobinfo", blobInfo)

      let results = await api.generalUploadImage(null, null, image)

      if (results.success) {
        success(results.image.url)
        this.pastedImages.push(results.image.id)
        const editor = this.$refs.editor.editor;
        console.log("Doing timeout...")
        setTimeout( () => {
          const imgs = editor.dom.select('img[src="' + results.image.url + '"]');
          console.log("Images ", imgs)
          if (imgs.length > 0) {
            editor.dom.setStyles(imgs[0], {'width': "33%"})
            editor.dom.addClass(imgs[0], "gp-user-image-left")
          }
        }, 200);
      }
      else {
        failure(results.message, {remove: true})
      }
      this.$store.dispatch("setExecuting", false)

    },
  }

};
</script>
